/**
 * Created by caroline on 7/21/15.
 */

'use strict';

const $ = require('dibs-jquery-shim');
const User = require('../../../models/User');
const createStore = require('fluxible/addons/createStore');
const ActionConstants = require('../actions/ActionConstants');
const NavActions = ActionConstants.NAV;

const DEFAULT_USER_INITIALS = null;
const DEFAULT_MESSAGE_COUNT = 0;
const DEFAULT_REDIRECT_URL = null;

/**
 * Stores the list of components that are displayed in the nav bar.
 */
module.exports = createStore({

    storeName: 'NavBarHamburgerStateStore',

    handlers: {
        [ActionConstants.HAMBURGER.UPDATE_USER_STATES]: '_onUpdateUserStates',
        [NavActions.ACTIVE_GROUP_CHANGED]: 'onActiveGroupChange',
        [NavActions.RECEIVED_LIST_DATA]: 'setLists'
    },

    initialize() {
        this.state = this._getDefaultState();
        this.lists = [];

        // set up listener on User Model
        User.getCurrentUser().on('login:change', this.updateUserStates, this);
        User.getCurrentUser().on('change:profile', this.updateUserStates, this);
    },

    getRedirectURL() {
        return this.redirectURL || DEFAULT_REDIRECT_URL;
    },

    getState() {
        return this.state;
    },

    getLists() {
        return this.lists;
    },

    setLists(payload) {
        this.lists = this._getFormattedListsData(payload);
        this.emitChange();
    },

    onActiveGroupChange(payload) {
        this.redirectURL = payload.redirectURL;
        this.emitChange();
    },

    /**
     * checks the user model, updates state.user and emits change
     * @param {promise} [payload.promise]
     */
    updateUserStates() {
        const loggedIn = User.loggedIn();

        if (loggedIn) {
            User.load().always(() => {
                this.state = {
                    loggedIn: loggedIn,
                    userInitials: User.getInitials() || DEFAULT_USER_INITIALS,
                    messageCount: User.getCurrentUser().get('conversationSummary.totalUnreadMessageCount')
                };
                this.emitChange();
            });
        } else {
            this.state = this._getDefaultState();
            this.emitChange();
        }
    },

    _onUpdateUserStates() {
        this.updateUserStates();

        //todo: revisit this and try to see if there is a better way to do this
        $.subscribe('reloadUserNav', (obj, data) => {
            this.state.messageCount = data.totalUnreadMessageCount;
            this.emitChange();
        });
    },

    _getDefaultState() {
        return {
            loggedIn: false,
            userInitials: DEFAULT_USER_INITIALS,
            messageCount: DEFAULT_MESSAGE_COUNT
        };
    },

    _getFormattedListsData({ modules }) {
        // Group the global nav items based on their is_vertical flags.
        return [
            {
                'label': 'Explore',
                'items': modules.filter(item => item.isVertical === true).map(item => {
                    return {
                        'url': item.url,
                        'name': item.name
                    };
                })
            },
            {
                'label': 'Discover',
                'items': modules.filter(item => item.isVertical !== true).map(item => {
                    return {
                        'url': item.url,
                        'name': item.name
                    };
                })
            }
        ];
    }
});




// WEBPACK FOOTER //
// ./assets/js/global/core/nav/stores/NavBarHamburgerStateStore.es.js